import { useQuery } from '@tanstack/react-query';
import { API } from '../api/client';
import type { ParametrosGlobales } from '../api/types';
import { useAuth } from '../auth/AuthContext';

// Fallback cuando aún no se ha cargado o el usuario no tiene permiso parametros:read.
export const MARGEN_OBJETIVO_DEFAULT = 0.3;

/**
 * Precio sugerido para alcanzar el margen objetivo:
 *   precioSugerido = costoTotalPaq / (1 - margenObjetivo)
 */
export function precioSugerido(costoTotalPaq: number, margenObjetivo = MARGEN_OBJETIVO_DEFAULT): number {
  if (margenObjetivo >= 1) return costoTotalPaq;
  return costoTotalPaq / (1 - margenObjetivo);
}

/** Lee parámetros globales y expone valores numéricos ya parseados. */
export function useParametros() {
  const { tiene } = useAuth();
  const q = useQuery({
    queryKey: ['parametros-globales'],
    queryFn: () => API.get<ParametrosGlobales>('/parametros'),
    enabled: tiene('parametros:read'),
    staleTime: 60_000,
  });

  const p = q.data;
  const margenObjetivo = p ? Number(p.margenObjetivo) : MARGEN_OBJETIVO_DEFAULT;
  const arriendo = p ? Number(p.arriendoMensual) : 0;
  const servicios = p ? Number(p.serviciosMensual) : 0;
  const internet = p ? Number(p.internetMensual) : 0;
  const otros = p ? Number(p.otrosFijosMensual) : 0;
  const costosFijosAdicionales = arriendo + servicios + internet + otros;

  return {
    data: p,
    margenObjetivo,
    paquetesMesEstimados: p?.paquetesMesEstimados ?? 100,
    arriendo,
    servicios,
    internet,
    otros,
    costosFijosAdicionales,
    isLoading: q.isLoading,
  };
}
